(() => {
  if (window.zgCartRewardInitialized) return;
  window.zgCartRewardInitialized = true;

  const giftVariantIds = new Set([
    '49222698205255',
    '49222698270791',
    '49222698336327',
    '49222698401863',
    '49222698467399',
    '49222698238023',
    '49222698303559',
    '49222698369095',
    '49222698434631',
    '49222698500167'
  ]);

  const root = window.Shopify?.routes?.root || '/';
  let refreshTimer;
  let refreshInProgress = false;

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(cents / 100);
  }

  function updateRewardBars(cart) {
    const bars = document.querySelectorAll('[data-zg-cart-reward]');
    if (!bars.length) return;

    let qualifyingSubtotal = 0;
    let giftInCart = false;

    (cart.items || []).forEach((item) => {
      const variantId = String(item.variant_id);

      if (giftVariantIds.has(variantId)) {
        giftInCart = true;
      } else {
        qualifyingSubtotal += Number(item.original_line_price || 0);
      }
    });

    bars.forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 12000);
      const remaining = Math.max(0, threshold - qualifyingSubtotal);
      const progress = Math.min(
        100,
        (qualifyingSubtotal / threshold) * 100
      );

      const message = bar.querySelector('[data-zg-reward-message]');
      const fill = bar.querySelector('[data-zg-reward-fill]');
      const progressBar = bar.querySelector('[role="progressbar"]');

      if (message) {
        if (qualifyingSubtotal >= threshold && giftInCart) {
          message.textContent =
            'Your free tank reward is unlocked! Your automatic discount will be applied at checkout.';
        } else if (qualifyingSubtotal >= threshold) {
          message.textContent =
            "You've unlocked your free tank! Add the Fear No Evil Boxy Tank in your preferred size and graphic to receive it free.";
        } else {
          message.textContent =
            `Spend ${formatMoney(remaining, cart.currency)} more to unlock your free Fear No Evil Boxy Tank.`;
        }
      }

      if (fill) {
        fill.style.width = `${progress}%`;
      }

      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', String(Math.round(progress)));
      }

      bar.dataset.qualifyingSubtotal = String(qualifyingSubtotal);
      bar.dataset.giftInCart = String(giftInCart);
    });
  }

  async function refreshCartRewards() {
    if (refreshInProgress) return;

    refreshInProgress = true;

    try {
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Could not retrieve cart');

      const cart = await response.json();
      updateRewardBars(cart);
    } catch (error) {
      console.warn('Zero Glory reward update:', error);
    } finally {
      refreshInProgress = false;
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartRewards, 250);
  }

  // Refresh after Shopify cart add, change, update or clear requests.
  if (window.fetch) {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then((response) => {
        const request = args[0];
        const requestUrl =
          typeof request === 'string'
            ? request
            : request?.url || '';

        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(requestUrl)) {
          scheduleRefresh();
        }

        return response;
      });
    };
  }

  // Initial update and refresh when the customer returns to the page.
  document.addEventListener('DOMContentLoaded', refreshCartRewards);
  window.addEventListener('pageshow', refreshCartRewards);

  // Prestige and Shopify section events.
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);

  refreshCartRewards();
})();